import { validateEmail } from '@app/libs/validation';
import { RootState } from '@app/store/types';

export const participantSelector = (state: RootState) => state.participant;

export const getContactInfo = (state: RootState) => participantSelector(state).contactInfo;
export const getDocumentId = (state: RootState) => participantSelector(state).documentId;
export const getRequester = (state: RootState) => participantSelector(state).requester;
export const getRequesterName = (state: RootState) => getRequester(state).name;
export const getParticipantId = (state: RootState) => participantSelector(state).participantId;
export const getSigningMethodType = (state: RootState) =>
  participantSelector(state).signingMethodType;
export const isFetching = (state: RootState) => participantSelector(state).isFetching;

export const getHost = (state: RootState) => participantSelector(state).host;

/**
 * 서명자의 수신처 정보가 이메일인지 여부를 반환한다.
 */
export const isEmailContactInfo = (state: RootState) =>
  validateEmail(getContactInfo(state) ?? '').success;
